/**
 * PoolsPage - Phase 2C-2 (PROPERLY FIXED)
 * 
 * Pool browser with filters.
 * Removed unused imports.
 */

import { useState } from 'react';
import { PoolFilters as PoolFiltersType } from '../types';
import { usePools } from '../hooks/usePools';
import { useJoinPool } from '../hooks/useJoinPool';
import { Card, CardContent, LoadingSpinner, Alert } from '../components/common';
import { PoolCard } from '../components/pools/PoolCard';
import { PoolFilters } from '../components/pools/PoolFilters';

export function PoolsPage(): JSX.Element {
  const [filters, setFilters] = useState<PoolFiltersType>({});
  const { pools, loading, error, refetch } = usePools(filters);
  const { joinPool, loading: joining, error: joinError, reset: resetJoin } = useJoinPool();

  const handleJoinPool = async (poolId: string) => {
    resetJoin();
    const result = await joinPool(poolId);
    if (result) {
      refetch();
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">Pools</h1>
        <p className="text-slate-400 mt-1">
          Browse and join prediction pools
        </p>
      </div>

      {/* Filters */}
      <div className="mb-6">
        <PoolFilters
          filters={filters}
          onFiltersChange={setFilters}
        />
      </div>

      {/* Error Messages */}
      {error && (
        <Alert variant="error" className="mb-6">
          {error}
        </Alert>
      )}
      {joinError && (
        <Alert variant="error" className="mb-6" onClose={resetJoin}>
          {joinError}
        </Alert>
      )}

      {/* Pool Count */}
      <p className="text-sm text-slate-400 mb-4">
        Showing {pools.length} pool{pools.length !== 1 ? 's' : ''}
      </p>

      {/* Pool Grid */}
      {pools.length === 0 ? (
        <Card>
          <CardContent>
            <div className="text-center py-8">
              <p className="text-slate-400">No pools match your filters</p>
            </div>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {pools.map((pool) => (
            <PoolCard
              key={pool.pool_id}
              pool={pool}
              onJoin={() => handleJoinPool(pool.pool_id)}
            />
          ))}
        </div>
      )}

      {joining && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-slate-800 p-6 rounded-lg flex items-center gap-3">
            <LoadingSpinner size="sm" />
            <span className="text-slate-100">Joining pool...</span>
          </div>
        </div>
      )}
    </div>
  );
}
